import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { ENTITY_SLUG_FIELD_NAME } from '@cli-constants/schema.js'
import { hasPersistedTitleField } from './has-persisted-title-field.js'

export function createGeneratedSlugField(fields: SchemaField[]): SchemaField {
  const sourceField = hasPersistedTitleField(fields) ? 'title' : undefined

  return {
    name: ENTITY_SLUG_FIELD_NAME,
    type: 'string',
    label: 'Slug',
    required: true,
    hint: 'URL-friendly identifier',
    ...(sourceField ? { defaultValueFrom: sourceField } : {})
  }
}
